import {FC} from 'react';
import {Box, IconButton} from '@mui/material';
import {ContentCopyOutlined, DescriptionOutlined} from '@mui/icons-material';
import {Link} from 'react-router-dom';
import {useIntl} from 'react-intl';
import copy from 'copy-to-clipboard';
import {PhoneCardHead} from 'src/components/mobile/PhoneCardHead';
import {PhoneCardFacts} from 'src/components/mobile/PhoneCardFacts';
import {phonePillsRowSx} from 'src/components/mobile/mobileDesign.sx';
import {AppRouteEnum, AppRouteSpace} from '../../../utils/helper';
import {ContractDTO} from '../../../types';
import {NotifySuccess} from '../../../utils/notification';
import {ColorField} from '../../common/ColorField';
import {contractItemSx} from './ContractItem.sx';
import {TableCard} from '../../tables/respnsiveTable/TableCard';

export const ContractItemCard: FC<ContractDTO> = ({
                                                      id,
                                                      user,
                                                      created,
                                                      status,
                                                      location,
                                                      tariff,
                                                  }) => {
    const intl = useIntl();
    const copyToClipboard = () => {
        copy(String(id), {debug: true});
        NotifySuccess(intl.formatMessage({id: 'copiedSuccesfully'}));
    };

    return (
        <TableCard>
            <PhoneCardHead
                icon={<DescriptionOutlined/>}
                title={
                    <Box
                        component={Link}
                        to={AppRouteSpace([AppRouteEnum.app, AppRouteEnum.contracts, String(id)])}
                        sx={contractItemSx.titleLink}
                    >
                        {`${user?.firstName} ${user?.lastName}`}
                    </Box>
                }
                subtitle={tariff?.name}
                action={
                    <IconButton
                        onClick={copyToClipboard}
                        sx={contractItemSx.iconBtn}
                    >
                        <ContentCopyOutlined sx={{width: '0.75rem'}}/>
                    </IconButton>
                }
            />
            <Box sx={phonePillsRowSx}>
                <ColorField label={status}/>
            </Box>
            <PhoneCardFacts
                facts={[
                    {
                        label: intl.formatMessage({id: 'createdOnColumnHeader'}),
                        value: new Date(created).toLocaleDateString('fr-CH'),
                    },
                    {
                        label: intl.formatMessage({id: 'tariff'}),
                        value: tariff?.name ?? '-',
                    },
                    {
                        label: intl.formatMessage({id: 'pricePerMonthColumnHeader'}),
                        value: tariff?.monthlyFee ? tariff.monthlyFee / 100 : 0,
                    },
                    {
                        label: intl.formatMessage({id: 'locationColumnHeader'}),
                        value: location?.name ?? '-',
                    },
                ]}
            />
        </TableCard>
    );
};
